:host {
  display: block;
}

@media (width >= 992px) {
  .br-footer-category {
    padding-bottom: 48px;
  }
}
